import { Component, Input } from '@angular/core';

@Component({
    selector: 'my-app-sidenav-menu',
    styles: [],
    template: require('./sidenav-menu.component.html')
})

export class AppSidenavMenuComponent {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/sidenav/sidenav-menu/sidenav-menu.component.ts